import { CircularProgress, Stack, Typography } from "@mui/material"


export const NoData = ({distributionList}) => {
  return (
    <Stack width="100%" alignItems="center" marginTop="100px">
    {
        distributionList !== 'isLoading' ?
        <Typography>No hay inversiones</Typography>
        : <CircularProgress />
    }
    </Stack>
  )
}
